import React from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { useLocation } from 'react-router-dom'
import { useGetCorporateBySubdomainQuery } from '_hooks/use-coporate-integrations.hooks'
import { extractSubdomain } from '../services/tenant.service'

const useCorporateStore = create(
  persist(
    (set) => ({
      corporate: null,
      brandName: null,
      logoUrl: null,
      dashboardHeroImageUrl: null,

      setCorporateData: (corporate, brandName, logoUrl, dashboardHeroImageUrl) => {
        set({
          corporate,
          brandName,
          logoUrl,
          dashboardHeroImageUrl,
        })
      },

      reset: () =>
        set({
          corporate: null,
          brandName: null,
          logoUrl: null,
          dashboardHeroImageUrl: null,
        }),
    }),
    {
      name: 'corporate-storage',
      partialize: (state) => ({
        brandName: state.brandName,
        logoUrl: state.logoUrl,
      }),
    }
  )
)

export const useCorporateWithStore = () => {
  const {
    setCorporateData,
    brandName: cachedBrandName,
    logoUrl: cachedLogoUrl,
  } = useCorporateStore()
  const location = useLocation()

  const urlPrefix = extractSubdomain()

  const { data: corporate, isLoading: loadingCorporateByPrefix } =
    useGetCorporateBySubdomainQuery(urlPrefix)

  const {
    name: apiBrandName,
    logoImage,
    dashboardHeroImage,
  } = corporate?.corporateBySubdomain || {}
  const apiLogoUrl = logoImage?.url
  const apiDashboardHeroImageUrl = dashboardHeroImage?.url

  React.useEffect(() => {
    if (corporate && apiBrandName) {
      setCorporateData(corporate, apiBrandName, apiLogoUrl, apiDashboardHeroImageUrl)
    }
  }, [corporate, apiBrandName, apiLogoUrl, apiDashboardHeroImageUrl, setCorporateData])

  // Use cached values immediately, fall back to API values when available
  const brandName = apiBrandName || cachedBrandName
  const logoUrl = apiLogoUrl || cachedLogoUrl

  return {
    corporate,
    brandName,
    logoUrl,
    dashboardHeroImageUrl: apiDashboardHeroImageUrl || null,
    // Only show loading if we have no cached data AND API is still loading
    isLoading: loadingCorporateByPrefix && !cachedBrandName,
  }
}

export default useCorporateStore
